import Units from 'common/enums/UnitEnum';

export class MetricColumnHelper {
    static getDistanceColumnProps = columnId => ({ t, unitConverter }) => {
        const { abbr, plural, system } = unitConverter.getPreferredUnit({
            sourceUnit: Units.list.length.Meter
        });
        const distanceUnit =
            system === 'imperial' ? plural.toLowerCase() : abbr;
        return {
            unit: t(`translations:units.${distanceUnit}`),
            limit: t(columnId)
        };
    };

    static getWeightColumnProps = columnId => ({ t, unitConverter }) => {
        const weightUnit = unitConverter.getPreferredUnit({
            sourceUnit: Units.list.mass.Gram
        }).abbr;
        return {
            unit: t(`translations:units.${weightUnit}`),
            limit: t(columnId)
        };
    };
}

export default MetricColumnHelper;
